import React from 'react';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';

const useStyles = makeStyles({
    card: {
        width: 'fit-content'
    },
});

export default function UsuarioProfile({ usuario, handleTrocaUsuario }) {
    const classes = useStyles();

    return (
        <Card className={classes.card} variant="outlined">
            <CardContent>
                <div style={{
                    display: 'flex'
                }}>
                    <div style={{
                        marginRight: '30px'
                    }}>
                        <Typography variant="body1" color="textSecondary" gutterBottom>
                            Nome
                        </Typography>
                        <Typography variant="body1" >
                            {usuario.nome}
                        </Typography>
                    </div>
                    <div>
                        <Typography variant="body1" color="textSecondary" gutterBottom>
                            E-mail
                        </Typography>
                        <Typography variant="body1" >
                            {usuario.email}
                        </Typography>
                    </div>
                </div>
                <CardActions>
                    <Button
                        onClick={handleTrocaUsuario}
                        size="small"
                        color="secondary"
                        variant="contained"
                    >Trocar Usuário</Button>
                </CardActions>

            </CardContent>
        </Card>
    );
}